/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('reportPassagesCtrl', reportPassagesCtrl);

    reportPassagesCtrl.$inject = ['tabs', 'userSession', 'type', 'flightService', 'reportPassagesService', 'linkService',
        'dateService', 'printService', 'userService', 'excelService', 'datePickerService','airports'];

    function reportPassagesCtrl(tabs, userSession, type, flightService, reportPassagesService, linkService, dateService,
                                     printService, userService, excelService, datePickerService, airports) {
        var vm = this;
        vm.tabs = tabs;
        vm.flights = [];
        vm.type = type;
        // vm.pages = paginationService.getPages();
        vm.airports = getAirport(airports);
        vm.isReport = false;
        vm.eventFlights = eventFlights;
        vm.reportPassagesHtml = '';
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(userSession.data.positionType);
        vm.filterReportPassages = {
            fromDate: new Date(),
            toDate: null
        };

        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                var dateAux = new Date(args.closeDate);
                var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 7));
                vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.cancel = function() {
            linkService.reloadRoute(type, null);
        };

        vm.generateReportPassages = function (isValid) {
            if(isValid) {
                var fromDate, toDate;
                fromDate = dateService.dateTimeString(vm.filterReportPassages.fromDate, 1);
                toDate = dateService.dateTimeString(vm.filterReportPassages.toDate, 1);
                if (vm.type === 'postCheckInPassageAnnulment') {
                    reportPassagesService.getPostCheckInPassageAnnulment(fromDate, toDate)
                        .then(function (response) {
                            onSuccess(response);
                        });
                } else if (vm.type === 'postCheckInAnnulment') {
                    reportPassagesService.getUnCheckPnr(fromDate, toDate)
                        .then(function (response) {
                            onSuccess(response);
                        });
                } else if (vm.type === 'airportTax'){
                    reportPassagesService.getAirportTax(fromDate, toDate, linkService.getLinkId(vm.airport._links.self.href))
                        .then(function (response) {
                            onSuccess(response);
                        });

                }
            }
        };

        vm.generatePdfHtml = function (target) {
            printService.printPdfHtml(target);
        };

        vm.generateToExcel = function (contendId) {
            var nameReport = vm.type === 'postCheckInPassageAnnulment' ? 'reporte_anulacion_pasaje_post_check_in' :(vm.type === 'postCheckInAnnulment' ? 'anulacion_de_pasaje_post_check_in' : 'reporte_de_tasas');
            excelService.exportDataToExcel(contendId, nameReport);
        };

        function onSuccess(response) {
            vm.reportPassagesHtml = response.data !== "" ? response.data : "";
            vm.isReport = response.data !== "" ? true : false;
        }

        function eventFlights(){
            if(vm.filterProduction.fromDate !== undefined){
                vm.flights= [];
                flightService.getFlightsFromDate(vm.filterProduction.fromDate.getTime())
                    .then(function (response) {
                        angular.forEach(response.data._embedded.flights, function(flight){
                            var departureFlightIds = '';
                            angular.forEach(flight._embedded.departureflights, function(departureFlight, index) {
                                if (flight._embedded.departureflights.length === 1) {
                                    departureFlightIds = departureFlightIds + 'departureFlightIds=' + linkService.getLinkId(departureFlight._links.self.href);
                                } else {
                                    if (index === 0) {
                                        departureFlightIds = departureFlightIds + 'departureFlightIds=' + linkService.getLinkId(departureFlight._links.self.href);
                                    } else {
                                        departureFlightIds = departureFlightIds + '&departureFlightIds=' + linkService.getLinkId(departureFlight._links.self.href);
                                    }
                                }
                            });
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials,
                                departureFlightIds: departureFlightIds
                            });
                        });
                    });
            }
        }

        function getAirport(airports){
            var resAirports = [];
            angular.forEach(airports, function(airport){
                if(airport.iata=="CBB" || airport.iata=="LPB" || airport.iata=="VVI" || airport.iata=="CIJ"){
                    resAirports.push(airport);
                }
            });
            return resAirports;
        }
    }

})();
